import React from 'react'
import PropTypes from 'prop-types'
import utils from '../../../lib/utils'
import stripperAndCategorizer from '../../../lib/blog-utils/blog-post-stripper-and-categorizer'
import { getUrlForBlogPost, getShortTextForCard } from '../../../lib/blog-utils/blog-utils'
import { BlogPost } from '../../../models/BlogPost'

const CommunityStory = (props: {
  size: "big" | "small",
  post: BlogPost,
  shortTextLength: number
  currentLang: string
}) => {
  const className = 'community-story ' + props.size
  const post = props.post
  const title = utils.decodeHtml(post.title?.rendered!)
  const details = getShortTextForCard(post, props.shortTextLength)
  const categoryLabel = stripperAndCategorizer.getTagTextFromCategories(post.categories.map(c => c.id))
  
  return (
    <div className={className}>
      <a href={getUrlForBlogPost(post, props.currentLang)}  rel="noopener noreferrer" target="_blank">
        <img className="community-story-picture" src={post.featured_picture_medium_large} alt="blog-post picture"/>
        <p className="community-story-info community-story-category">{categoryLabel}</p>
        <p className="community-story-info community-story-title">{title}</p>
        <div className="community-story-expand">
          <p className="community-story-info community-story-expand-category">{categoryLabel}</p>
          <p className="community-story-expand-title">{title}</p>
          <p className="community-story-short-text">{details}</p>
          <p className="community-story-more">Read more &gt;</p>
        </div>
      </a>
    </div>
  )
}

CommunityStory.propTypes = {
  size: PropTypes.string,
  post: PropTypes.object,
  showDetails: PropTypes.bool,
  className: PropTypes.string,
  shortTextLength: PropTypes.number,
  currentLang: PropTypes.string
}


export default CommunityStory